export default __webpack_public_path__ + "static/media/circle.811f3a70.svg";